import styled from "styled-components";

export const StyledAPImageWrapper = styled.div`
    margin-top: 20px;
    height: 200px;

    img {
        border-radius: 4px;
        object-fit: contain;
    }

    margin-bottom: 16px;
`;

export const StyledGalleryWrapper = styled.div`
    width: 100%;
    border: 1px dashed ${({ theme }) => theme.secondaryBorderColor};
    border-radius: 8px;
`;
